import { initialCommercialManagementInvoicesConfig } from '@commercialManagement/pages/invoices/store/invoiceConfig';
import {
  CLIENT_PORTFOLIO_DOCUMENTS_CONFIG_KEY,
  DEBTOR_PORTFOLIO_DOCUMENTS_CONFIG_KEY,
  initialClientPortfolioDocumentsConfig,
  initialDebtorPortfolioDocumentsConfig,
} from '@riskMatrix/store/documentsConfig';

import { type DataSetConfig, type DataSetsState } from '../types';
import { initialDocumentsConfig } from './initialDocumentsConfig';
import { initialOperationsConfig } from './initialOperationsConfig';
import { initialSalesAndPurchaseConfig } from './initialSalesAndPurchaseConfig';
import { initialSalesConfig } from './initialSalesConfig';

const initialShareholdersConfig: DataSetConfig = {
  sorting: [{ field: 'types', order: 'asc' }],
};

const initialClientMaintainerConfig: DataSetConfig = {
  sorting: [{ field: 'name', order: 'asc' }],
  pagination: { pageSize: 20, pageIndex: 0 },
};

const initialAssignedTotalsConfig: DataSetConfig = {
  sorting: [{ field: 'totalAmount', order: 'desc' }],
};

const initialDicomConfig: DataSetConfig = {
  sorting: [{ field: 'amount', order: 'desc' }],
};

const initialRealStatesConfig: DataSetConfig = {
  sorting: [{ field: 'totalAppraisal', order: 'desc' }],
};

const initialSbifDebtsConfig: DataSetConfig = {
  sorting: [{ field: 'period', order: 'desc' }],
};

const initialVehiclesConfig: DataSetConfig = {
  sorting: [{ field: 'appraisal', order: 'desc' }],
};

const initialJudicialDebtCollectionsConfig: DataSetConfig = {
  sorting: [{ field: 'year', order: 'desc' }],
};

const initialTaxDebtCertificatesConfig: DataSetConfig = {
  sorting: [{ field: 'total', order: 'desc' }],
};

const initialCurrentAgreementsConfig: DataSetConfig = {
  sorting: [{ field: 'amount', order: 'desc' }],
};

const initialCivilCourtCasesConfig: DataSetConfig = {
  sorting: [{ field: 'date', order: 'desc' }],
};
const initialDebtCollectionCourtCasesConfig: DataSetConfig = {
  sorting: [{ field: 'entryDate', order: 'desc' }],
};

const initialEmploymentCourtCasesConfig: DataSetConfig = {
  sorting: [{ field: 'entryDate', order: 'desc' }],
};

const initialDicomLaborCommercialBulletin: DataSetConfig = {
  sorting: [{ field: 'date', order: 'desc' }],
};

const initialEmails: DataSetConfig = {
  sorting: [{ field: 'email', order: 'asc' }],
};

const initialPhoneNumbers: DataSetConfig = {
  sorting: [{ field: 'phoneNumber', order: 'asc' }],
};

const initialAddresses: DataSetConfig = {
  sorting: [{ field: 'address', order: 'asc' }],
};

const initialDataSetsState: DataSetsState = {
  currentAgreements: initialCurrentAgreementsConfig,
  taxDebtCertificates: initialTaxDebtCertificatesConfig,
  judicialDebtCollections: initialJudicialDebtCollectionsConfig,
  vehicles: initialVehiclesConfig,
  sbifDebts: initialSbifDebtsConfig,
  dicom: initialDicomConfig,
  realStates: initialRealStatesConfig,
  shareholders: initialShareholdersConfig,
  documents: initialDocumentsConfig,
  sales: initialSalesConfig,
  operations: initialOperationsConfig,
  clientMaintainer: initialClientMaintainerConfig,
  salesAndPurchase: initialSalesAndPurchaseConfig,
  assignedTotals: initialAssignedTotalsConfig,
  civilCourtCases: initialCivilCourtCasesConfig,
  debtCollectionCourtCases: initialDebtCollectionCourtCasesConfig,
  employmentCourtCases: initialEmploymentCourtCasesConfig,
  dicomLaborCommercialBulletin: initialDicomLaborCommercialBulletin,
  emails: initialEmails,
  phoneNumbers: initialPhoneNumbers,
  addresses: initialAddresses,
  commercialManagementInvoices: initialCommercialManagementInvoicesConfig,
  [CLIENT_PORTFOLIO_DOCUMENTS_CONFIG_KEY]:
    initialClientPortfolioDocumentsConfig,
  [DEBTOR_PORTFOLIO_DOCUMENTS_CONFIG_KEY]:
    initialDebtorPortfolioDocumentsConfig,
  version: 'v1.0.12',
};

export { initialDataSetsState };
